import {
  VendorInformationTemplate,
  MainLayout,
} from "@/design-system/Templates";
import Header from "@/design-system/Organisms/Header";
import { headerConfig } from "@/design-system/Organisms/Header/Header.config";
import { Footer } from "@/design-system/Organisms";

const VendorInformationPage = () => (
  <MainLayout
    header={<Header {...headerConfig} />}
    sidebar={null}
    className=""
    footer={<Footer />}
  >
    <VendorInformationTemplate />
  </MainLayout>
);

export default VendorInformationPage;
